<div
    [style]="style"
    class="sera-footer-bar">
    <ng-content select="sera-button[footer-bar]"></ng-content>
</div>
